import { Box, Paper, Typography, Button, IconButton } from '@mui/material';
import { NotificationsActive, Close } from '@mui/icons-material';
import { useNotifications } from '../../contexts/NotificationContext';

/**
 * A banner that prompts the user to enable push notifications.
 * Shown once after login if the browser permission state is "default".
 * The user can accept (triggering the browser permission dialog) or dismiss.
 */
export default function NotificationPermissionPrompt() {
  const { showPermissionPrompt, subscribeToPush, dismissPermissionPrompt } = useNotifications();

  if (!showPermissionPrompt) return null;

  const handleEnable = async () => {
    await subscribeToPush();
  };

  return (
    <Paper
      elevation={3}
      sx={{
        position: 'fixed',
        bottom: 24,
        left: '50%',
        transform: 'translateX(-50%)',
        zIndex: 1400,
        maxWidth: 440,
        width: 'calc(100% - 32px)',
        p: 2,
        display: 'flex',
        alignItems: 'center',
        gap: 1.5,
        borderRadius: 3,
        bgcolor: '#0F1830',
        color: '#fff',
        border: '1px solid rgba(110, 147, 255, 0.35)',
      }}
    >
      <NotificationsActive sx={{ color: 'var(--color-secondary-500)', fontSize: 32 }} />

      <Box sx={{ flex: 1, minWidth: 0 }}>
        <Typography variant="subtitle2" fontWeight={700}>
          Stay in the loop!
        </Typography>
        <Typography variant="caption" sx={{ color: 'rgba(255,255,255,0.7)' }}>
          Enable notifications to get alerts for new announcements, recognition &amp; more.
        </Typography>
      </Box>

      <Button
        variant="contained"
        size="small"
        onClick={handleEnable}
        sx={{
          bgcolor: 'var(--color-primary-500)',
          color: '#fff',
          fontWeight: 700,
          textTransform: 'none',
          whiteSpace: 'nowrap',
          '&:hover': { bgcolor: '#244BC0' },
        }}
      >
        Enable
      </Button>

      <IconButton size="small" onClick={dismissPermissionPrompt} sx={{ color: 'rgba(255,255,255,0.5)' }}>
        <Close fontSize="small" />
      </IconButton>
    </Paper>
  );
}
